import React from 'react';
import { motion } from 'framer-motion';
import { Star, BadgeCheck, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Roberto C.',
  role: 'Repuestos Automotrices',
  initials: 'RC',
  color: 'from-cyan-500 to-blue-500',
  quote: 'Controlar el inventario de mis repuestos era un caos total. Ahora con el archivo sé exactamente qué tengo y qué cobrar. Meto mis facturas de compra y se suma todo solo. Vale cada centavo.'
}, {
  name: 'Andrea P.',
  role: 'Minimarket (3 Cajas)',
  initials: 'AP',
  color: 'from-green-400 to-emerald-600',
  quote: 'Lo instalé en mis 3 computadoras y funciona perfecto con la tiquetera de 80mm. Guardo los tickets de crédito en PDF y se los mando por WhatsApp a los clientes. Súper profesional.'
}, {
  name: 'Carlos V.',
  role: 'Bodega y Purificadora',
  initials: 'CV',
  color: 'from-pink-500 to-rose-500',
  quote: 'Yo le tenía miedo a la tecnología porque no sé mucho de computadoras, pero los tutoriales son súper fáciles y Arturo me dio soporte por WhatsApp. Ya sé cuánto gano diario.'
}];
export function Testimonials() {
  return <section className="py-24 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto relative" data-id="element-308">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] bg-gradient-to-r from-cyan-900/10 to-green-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-309" />

      <div className="text-center mb-16 relative z-10" data-id="element-310">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-white tracking-tight mb-6" data-id="element-311">
          Más de <span className="text-cyan-400" data-id="element-312">100 Negocios</span> ya organizaron<br data-id="element-313" />sus finanzas este mes.
        </motion.h2>
        <p className="text-gray-400 text-lg max-w-2xl mx-auto font-light" data-id="element-314">
          Casos reales de dueños de negocios en Venezuela que dejaron de adivinar sus ganancias y tomaron el control total.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-315">
        {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.15
      }} className="group bg-[#0a0a0a] border border-white/5 rounded-3xl p-8 hover:border-cyan-500/30 hover:bg-white/[0.02] transition-all duration-300" data-id="element-316">
            <Quote className="absolute top-6 right-6 w-12 h-12 text-white/5 group-hover:text-cyan-500/10 transition-colors duration-300 transform rotate-180" data-id="element-317" />
            <div className="flex gap-1 mb-6" data-id="element-318">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400 drop-shadow-[0_0_8px_rgba(250,204,21,0.4)]" data-id="element-319" />)}
            </div>
            <p className="text-gray-300 text-lg mb-8 flex-grow leading-relaxed font-light relative z-10" data-id="element-320">
              "{testimonial.quote}"
            </p>
            <div className="flex items-center gap-4 border-t border-white/5 pt-6 mt-auto" data-id="element-321">
              <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${testimonial.color} flex items-center justify-center shadow-lg flex-shrink-0`} data-id="element-322">
                <span className="font-bold text-white text-lg tracking-wider" data-id="element-323">{testimonial.initials}</span>
              </div>
              <div data-id="element-324">
                <div className="flex items-center gap-1.5" data-id="element-325">
                  <p className="font-heading font-bold text-white text-lg tracking-tight" data-id="element-326">{testimonial.name}</p>
                  <BadgeCheck className="w-5 h-5 text-cyan-400" data-id="element-327" />
                </div>
                <p className="text-cyan-400/80 text-sm font-medium" data-id="element-328">{testimonial.role}</p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}